@if (corporateTaxEntity$ | async) {
  <form [formGroup]="enkelvoudigFg">
    <div formArrayName="enkelvoudigecijfers">
      @for (item of enkelvoudigecijfers.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="row mb-0.5">
            @if (item.value.naamVennootschap !== 'Consolidatie' && item.value.naamVennootschap !== 'Eliminatie') {
              <div class="col-auto">
                <snelstart-ui-text-form-control
                  [label]="i === 0 ? 'Naam vennootschap' : ''"
                  [required]="true"
                  class="custom-input-250"
                  formControlName="naamVennootschap"
                  id="naamVennootschap"
                >
                </snelstart-ui-text-form-control>
              </div>

              <div class="col-auto">
                <snelstart-ui-bsn-form-control
                  [label]="i === 0 ? 'RSIN/fiscaal nummer' : ''"
                  [required]="true"
                  class="custom-input-150"
                  formControlName="fiscaalNummer"
                  id="fiscaalNummer"
                >
                </snelstart-ui-bsn-form-control>
              </div>
              <div class="col-auto">
                <div formGroupName="boekjaarVennootschap">
                  <snelstart-ui-date-form-control
                    [label]="i === 0 ? 'Aanvang' : ''"
                    [required]="true"
                    class="custom-input-150"
                    formControlName="begindatum"
                    id="begindatum"
                    placeholder="dd-mm-jjjj"
                  >
                  </snelstart-ui-date-form-control>
                </div>
              </div>
              <div class="col-auto">
                <div formGroupName="boekjaarVennootschap">
                  <snelstart-ui-date-form-control
                    [label]="i === 0 ? 'Einde' : ''"
                    [required]="true"
                    class="custom-input-150"
                    formControlName="einddatum"
                    id="einddatum"
                    placeholder="dd-mm-jjjj"
                  >
                  </snelstart-ui-date-form-control>
                </div>
              </div>
              @if (i > 0) {
                <div class="col-auto">
                  <snelstart-ui-button
                    (click)="verwijderRij(i)"
                    class="delete"
                    icon="trash"
                    iconType="light"
                    id="buttonDelete"
                    size="medium"
                    type="secondary"
                  >
                  </snelstart-ui-button>
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button
    (click)="addRij()"
    class="snelstart-ui-button"
    icon="plus"
    id="cancel"
    type="link"
  >Dochtermaatschappij toevoegen
  </snelstart-ui-button>
}
